﻿import { IProfile } from '@se360/header-components';

export type UserProfile = {
    identityServerId: number;
    username: string;
    firstName: string;
    lastName: string;
    readonly name: string;
    email: string;
    phoneNumber: string;
    mobileNumber: string;
    languageKey: string; // TODO: This should really be the property language, that actually also comes from backend now.
    timeZoneId: string;
};

export function createUserProfile(profile: {
    identityServerId: number;
    username: string;
    name: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    mobileNumber: string;
    languageKey: string;
    timeZoneId: string;
}): UserProfile {
    return {
        identityServerId: profile.identityServerId,
        username: profile.username,
        firstName: profile.firstName,
        lastName: profile.lastName,
        name:
            profile.firstName !== null &&
            profile.lastName !== null &&
            profile.firstName !== '' &&
            profile.lastName !== ''
                ? `${profile.firstName} ${profile.lastName}`
                : profile.name,
        email: profile.email ? profile.email : profile.username,
        phoneNumber: profile.phoneNumber,
        mobileNumber: profile.mobileNumber,
        languageKey: profile.languageKey,
        timeZoneId: profile.timeZoneId
    };
}

export function transformProfileForModal(userProfile: UserProfile): IProfile {
    return {
        id: userProfile.identityServerId,
        username: userProfile.username,
        name: userProfile.name,
        firstname: userProfile.firstName,
        lastname: userProfile.lastName,
        phoneNumber: userProfile.phoneNumber,
        mobile: userProfile.mobileNumber,
        languageKey: userProfile.languageKey,
        timeZoneId: userProfile.timeZoneId,
        email: userProfile.email
    };
}

export function transformProfileForPhoto(profile: IProfile): UserProfile {
    return createUserProfile({
        identityServerId: profile.id,
        username: profile.username,
        email: profile.email,
        name: profile.name,
        firstName: profile.firstname,
        lastName: profile.lastname,
        timeZoneId: profile.timeZoneId,
        mobileNumber: profile.mobile,
        phoneNumber: profile.phoneNumber,
        languageKey: profile.languageKey
    });
}
